/**
Author - Shreshtha Sharma
Git - https://github.com/shreshtha-wealthy
**/

import React, { useState, useEffect } from "react";
import Carousel from "./Carousel";

const CarouselContainer = ({ 
    data, 
    columns = 1, 
    showArrows = true, 
    renderItem 
}) => {
    const [activeIndex, setActiveIndex] = useState(0);

    if (!data?.length) {
        return null;
    }

    const carouselData = (() => {
        if (data && typeof data === "object" && !Array.isArray(data)) {
            return Object.values(data);
        } else if (!Array.isArray(data)) {
            console.error("This component expects an Array or an Object");
            return [];
        }
        return data;
    })();

    const totalSlides = Math.ceil(carouselData.length / columns);

    const handlePrevSlide = () => {
        setActiveIndex((prevIndex) => 
            prevIndex === 0 ? totalSlides - 1 : prevIndex - 1
        );
    };

    const handleNextSlide = () => {
        setActiveIndex((prevIndex) => 
            (prevIndex + 1) % totalSlides
        );
    };

    useEffect(() => {
        if (totalSlides <= 1) return;

        const interval = setInterval(() => {
            handleNextSlide();
        }, 3000);

        return () => clearInterval(interval);
    }, [totalSlides]);

    return (
        <Carousel
            activeIndex={activeIndex}
            data={carouselData}
            columns={columns}
            onPrevClick={handlePrevSlide}
            onNextClick={handleNextSlide}
            totalSlides={totalSlides}
            showArrows={showArrows}
            renderItem={renderItem}
        />
    );
};

export default React.memo(CarouselContainer);